export const SCHEDULE_SALE_ORDER_AFTER_N_DAYS = 'scheduleSaleOrderAfterNDays';
export const ENABLE_DUPLICATION_OF_LOAD_ORDERS = 'enableDuplicationOfLoadOrders';
export const SKIP_PACK_ENABLED = 'skipPackEnabled';
export const ENABLE_QUOTE_MANAGEMENT = 'enableQuoteManagement';
export const SHOW_SHIPPING_INFO = 'showShippingInfo';
export const ENABLE_QUICK_QUOTE_CONVERSION = 'enableQuickQuoteConversion';
export const ENABLE_ANYTIME_ON_ORDER = 'enableAnytimeOnOrder';
export const ENABLE_ORDER_LIST_COUNTS = 'enableOrderListCounts';
export const OPEN_AT_TYPE = 'openAtType';
